var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBaseuniverse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "globe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.94870821,0.579059017 C10.4665683,0.579059017 13.3183574,3.4308481 13.3183574,6.94870821 C13.3183574,10.4665683 10.4665683,13.3183574 6.94870821,13.3183574 C3.4308481,13.3183574 0.579059017,10.4665683 0.579059017,6.94870821 C0.579059017,3.4308481 3.4308481,0.579059017 6.94870821,0.579059017 Z M4.08390844,7.52745464 L1.76901264,7.5280257 C2.00836639,9.69226678 3.57298517,11.457043 5.63333721,11.9928225 C4.75151822,10.6686246 4.2163479,9.13563724 4.08390844,7.52745464 Z M12.1284133,7.52794071 L9.81500283,7.52770274 C9.6851684,9.12796483 9.14953685,10.6640539 8.26534172,11.9928863 C10.3249872,11.4564891 11.8891316,9.69187119 12.1284133,7.52794071 Z M8.6541826,7.52761433 L5.24486299,7.52758284 C5.39029213,9.09874326 5.98183346,10.5956247 6.94872087,11.8413121 C7.91924613,10.5911593 8.51158981,9.08959777 8.6541826,7.52761433 Z M5.63191904,1.90476409 L5.4618917,1.95234106 C3.48674277,2.53922307 2.00185734,4.26538808 1.76905392,6.36901758 L4.08245819,6.36916402 C4.21236304,4.76919375 4.74791793,3.2333906 5.63191904,1.90476409 Z M6.94869554,2.05610435 C5.97831955,3.30606483 5.38600882,4.80735676 5.24329964,6.36908138 L8.65255343,6.36983357 C8.50712428,4.79867315 7.91558295,3.30179166 6.94869554,2.05610435 Z M8.26508279,1.904855 L8.40609479,2.12288097 C9.20309804,3.39619497 9.68815474,4.84913495 9.81344886,6.36923172 L12.1284132,6.36947588 C11.8891299,4.20554734 10.3249663,2.44095358 8.26508279,1.904855 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.-Menu-General-",
    transform: "translate(-34.000000, -161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-Universes",
    transform: "translate(33.000000, 139.989154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Selection",
    transform: "translate(0.984816, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.998265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "globe",
    transform: "translate(0.000000, 1.199479)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 14.1412307,
    height: 14.1412307
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBaseuniverse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/baseuniverse.1c139df5.svg";
export { ForwardRef as ReactComponent };